<div class="job-approval-page">
  <div class="page-back-btn" (click)="goTojobApprovalPage()">
    <i class="bi bi-arrow-left"></i>
    <span>{{ origin === 'all-jobs' ? 'Back to All Jobs' : 'Back to Job Approvals' }}</span>
  </div>

  <ng-container *ngIf="isLoading; else pageContent">
    <div class="app-spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </ng-container>

  <ng-template #pageContent>
    <ng-container *ngIf="jobDetails; else showMessage">
      <div class="job-top-header" *ngIf="jobDetails">
        <div class="job-top-left">
          <div class="company-avatar" [style.background]="jobDetails.logo_url ? 'transparent' : '#4f46e5'">
            <img *ngIf="jobDetails.logo_url" [src]="jobDetails.logo_url" alt="Logo" class="company-logo-img" />
            <span *ngIf="!jobDetails.logo_url">
              {{ jobDetails.company_name.substring(0, 2).toUpperCase() }}
            </span>
          </div>
          <div class="job-top-content">
            <div class="job-title-row">
              <h1>{{ jobDetails.job_title }}</h1>
              <span class="status-badge" [ngClass]="{
                  active: jobDetails.status === 'active',
                  rejected: jobDetails.status === 'rejected',
                  pending: jobDetails.status === 'pending',
                }">{{ jobDetails.status }}</span>
            </div>
            <div class="job-meta">
              {{ jobDetails.company_name }} · {{ jobDetails.job_type }} ·
              {{ jobDetails.work_mode }} ·
              {{ jobDetails.locations.join(", ") }}
            </div>
          </div>
        </div>
        <div class="job-actions" *ngIf="jobDetails.status === 'pending'">
          <button class="approve-btn" (click)="openJobAcceptDialogBox(jobDetails)">
            <i class="bi bi-check-lg"></i>
            Approve Job
          </button>
          <button class="reject-btn" (click)="openJobRejectDialogBox(jobDetails)">
            <i class="bi bi-x-lg"></i>
            Reject
          </button>
        </div>
      </div>

      <div class="stats-row-grid" *ngIf="jobDetails">
        <div class="stat-card">
          <div class="stat-content">
            <span class="stat-label">APPLIED</span>
            <h3 class="stat-value">{{ jobDetails.stats.applications }}</h3>
          </div>
          <div class="stat-icon-wrapper applied">
            <i class="bi bi-person-plus-fill"></i>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-content">
            <span class="stat-label">MOCK DONE</span>
            <h3 class="stat-value">
              {{ jobDetails.stats.assessments_taken }}
            </h3>
          </div>
          <div class="stat-icon-wrapper mockdone">
            <i class="bi bi-people-fill"></i>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-content">
            <span class="stat-label">AI DONE</span>
            <h3 class="stat-value">{{ jobDetails.stats.interviews_taken }}</h3>
          </div>
          <div class="stat-icon-wrapper aidone">
            <i class="bi bi-person-check-fill"></i>
          </div>
        </div>
      </div>

      <div class="job-details-layout" *ngIf="jobDetails">
        <div class="main-details-column">
          <div class="detail-card funnel-card">
            <div class="card-header">
              <h2>Application funnel</h2>
            </div>
            <div class="card-body">
              <div class="funnel-stage">
                <div class="stage-header">
                  <span class="stage-name">Applied</span>
                  <span class="stage-count">
                    {{ jobDetails.stats.applications || 0 }}
                  </span>
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar-fill applied-bar" style="width: 100%"></div>
                </div>
              </div>

              <div class="funnel-stage">
                <div class="stage-header">
                  <span class="stage-name">Mock Test Completed</span>
                  <span class="stage-count">
                    {{ jobDetails.stats.assessments_taken || 0 }}
                  </span>
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar-fill mock-bar" style="width: 70%"></div>
                </div>
              </div>

              <div class="funnel-stage">
                <div class="stage-header">
                  <span class="stage-name">AI Interview Completed</span>
                  <span class="stage-count">
                    {{ jobDetails.stats.interviews_taken || 0 }}
                  </span>
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar-fill ai-bar" style="width: 41.25%"></div>
                </div>
              </div>

              <div class="funnel-stage">
                <div class="stage-header">
                  <span class="stage-name">Shortlisted</span>
                  <span class="stage-count">
                    {{ jobDetails.stats.shortlisted || 0 }}
                  </span>
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar-fill shortlisted-bar" style="width: 16.25%"></div>
                </div>
              </div>

              <!-- <div class="funnel-stage">
                <div class="stage-header">
                  <span class="stage-name">Selected</span>
                  <span class="stage-count">4</span>
                </div>
                <div class="progress-bar-container">
                  <div
                    class="progress-bar-fill selected-bar"
                    style="width: 5%"
                  ></div>
                </div>
              </div> -->
            </div>
          </div>

          <div class="detail-card">
            <div class="card-header">
              <i class="bi bi-briefcase-fill header-icon"></i>
              <h2>Basic Details</h2>
            </div>
            <div class="card-body">
              <div class="details-grid">
                <div class="detail-field">
                  <span class="field-label">Job Title</span>
                  <span class="field-value">{{
                    jobDetails.job_title || "-"
                    }}</span>
                </div>
                <div class="detail-field">
                  <span class="field-label">Role Category</span>
                  <span class="field-value">{{
                    jobDetails.job_role_category || "-"
                    }}</span>
                </div>
                <div class="detail-field">
                  <span class="field-label">Job Type</span>
                  <span class="field-value">{{
                    jobDetails.job_type || "-"
                    }}</span>
                </div>
                <div class="detail-field">
                  <span class="field-label">Work Mode</span>
                  <span class="field-value">{{
                    jobDetails.work_mode || "-"
                    }}</span>
                </div>
                <div class="detail-field">
                  <span class="field-label">Locations</span>
                  <span class="field-value" *ngFor="let location of jobDetails.locations">{{ location || "-" }}</span>
                </div>
                <div class="detail-field">
                  <span class="field-label">Deadline</span>
                  <span class="field-value">{{
                    (jobDetails.application_deadline | date: "dd MMM yyyy") ||
                    "-"
                    }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="detail-card">
            <div class="card-header">
              <i class="bi bi-mortarboard-fill header-icon"></i>
              <h2>Eligibility & Requirements</h2>
            </div>
            <div class="card-body">
              <div class="details-grid">
                <div class="detail-field">
                  <span class="field-label">Education</span>
                  <ng-container *ngIf="jobDetails.education.length; else noEducation">
                    <span class="field-value" *ngFor="let education of jobDetails.education">
                      {{ education || "-" }}</span>
                  </ng-container>
                  <ng-template #noEducation>-</ng-template>
                </div>
                <div class="detail-field">
                  <span class="field-label">Minimum CGPA</span>
                  <span class="field-value">{{
                    jobDetails.min_cgpa || "-"
                    }}</span>
                </div>
                <div class="detail-field">
                  <span class="field-label">Experience Required</span>
                  <span class="field-value">{{
                    jobDetails.experience_level || "-"
                    }}</span>
                </div>
                <div class="detail-field">
                  <span class="field-label">Year of Passing</span>
                  <span class="field-value">{{
                    jobDetails.year_of_passing.join(", ") || "-"
                    }}</span>
                </div>
                <div class="detail-field">
                  <span class="field-label">Salary / Stipend</span>
                  <span class="field-value">
                    <ng-container *ngIf="
                        jobDetails.salary_min && jobDetails.salary_max;
                        else showEmpty
                      ">
                      ₹{{ jobDetails.salary_min }} - ₹{{
                      jobDetails.salary_max
                      }}
                    </ng-container>
                    <ng-template #showEmpty>-</ng-template>
                  </span>
                </div>
                <div class="detail-field">
                  <span class="field-label">Openings</span>
                  <span class="field-value">{{ jobDetails.number_of_openings || "0" }} Position</span>
                </div>
              </div>
            </div>
          </div>

          <div class="detail-card">
            <div class="card-header">
              <i class="bi bi-file-earmark-text-fill header-icon"></i>
              <h2>Job Description & Requirements</h2>
            </div>
            <div class="card-body">
              <div class="description-section">
                <h4 class="section-subtitle">About the Role</h4>
                <p class="description-text">
                  {{ jobDetails.description || "-" }}
                </p>
              </div>

              <div class="description-section mt-4">
                <h4 class="section-subtitle">Roles & Responsibilities</h4>
                <ul class="roles-list">
                  <li>
                    {{ jobDetails.roles_and_responsibilities || "-" }}
                  </li>
                </ul>
              </div>

              <div class="skills-section mt-4">
                <div class="skills-grid">
                  <div class="skills-col">
                    <span class="field-label">Required Skills</span>
                    <div class="skills-wrapper">
                      <ng-container *ngIf="jobDetails.required_skills.length; else noSkill">
                        <span class="skill-chip" *ngFor="let skills of jobDetails.required_skills">
                          {{ skills || "-" }}
                        </span>
                      </ng-container>
                      <ng-template #noSkill>-</ng-template>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="sidebar-details-column">
          <div class="detail-card company-card">
            <div class="card-header">
              <h2>Submitted by</h2>
            </div>
            <div class="card-body">
              <div class="company-box-simple">
                <div class="company-logo-simple" [style.background]="jobDetails.logo_url ? 'transparent' : '#e8f0fe'">
                  <img *ngIf="jobDetails.logo_url" [src]="jobDetails.logo_url" alt="Logo" class="company-logo-img" />
                  <span *ngIf="!jobDetails.logo_url">
                    {{ jobDetails.company_name.substring(0, 1).toUpperCase() }}
                  </span>
                </div>
                <div class="company-info-simple">
                  <span class="company-name-simple">{{
                    jobDetails.company_name
                    }}</span>
                  <span class="company-date-simple">
                    Submitted on
                    {{ (jobDetails.submitted_at | date: "dd MMM yyyy") ||'-' }}</span>
                  <span class="company-date-simple">
                    Published on {{ (jobDetails.published_at | date:'dd MMM yyyy') || '-' }}
                  </span>

                  <span class="company-meta-simple">
                    {{ jobDetails.stats.applications || '0' }}
                    {{ jobDetails.stats.applications === 1 ? 'Application' : 'Applications' }}
                    &bull;

                    <span class="status-badge" [ngClass]="{
                  active: jobDetails.status === 'active',
                  rejected: jobDetails.status === 'rejected',
                  pending: jobDetails.status === 'pending',
                }">
                      {{ jobDetails.status | titlecase }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Perks & Benefits Card -->
          <div class="detail-card benefits-card">
            <div class="card-header">
              <i class="bi bi-gift-fill header-icon"></i>
              <h2>Perks & Benefits</h2>
            </div>
            <ng-container *ngIf="jobDetails.perks_and_benefits.length; else noPerks">
              <div class="card-body">
                <div class="benefits-vertical-list">
                  <div class="benefit-item" *ngFor="let perks of jobDetails.perks_and_benefits">
                    <div class="benefit-icon-wrapper">
                      <i class="bi bi-cash-stack"></i>
                    </div>
                    <div class="benefit-details">
                      <span class="benefit-desc">{{ perks }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #noPerks>
              <p class="text-center">Perks & Benefits not available.</p>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Candidate Card (Table) - Placed outside the layout columns to span full screen width-->
      <!-- <div class="detail-card candidate-table-card">
        <div class="card-header">
          <div class="header-title-wrapper">
            <i class="bi bi-people-fill header-icon"></i>
            <h2>Applied Candidates</h2>
          </div>
          <span class="candidate-count-badge">{{totalCandidates}} Candidates</span>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="candidate-table">
              <thead>
                <tr>
                  <th>Candidate</th>
                  <th>College & Degree</th>
                  <th>CGPA</th>
                  <th>Mobile</th>
                  <th>Status</th>
                  <th class="text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let candidates of allCandidates">
                  <td class="candidate-cell">
                    <div class="candidate-avatar color-1">{{candidates.name[0]}}</div>
                    <div class="candidate-info">
                      <span class="candidate-name">{{candidates.name || '-'}}</span>
                      <span class="candidate-contact"
                        >{{candidates.email || '-'}}</span
                      >
                    </div>
                  </td>
                  <td>
                    <div class="degree-info">
                      <span class="degree-name">{{candidates.subject || '-'}}</span>
                      <span class="college-name">{{candidates.previous_institute || '-'}}</span>
                    </div>
                  </td>
                  <td><strong class="cgpa-text">{{candidates.cgpa || '-'}}</strong></td>
                  <td>
                    <div class="score-badge passed">
                      <i class="bi bi-phone"></i>
                      <span>{{candidates.mobile || '-'}}</span>
                    </div>
                  </td>
                  <td>
                    <span class="status-pill status-shortlisted"
                      >{{candidates.status || '-'}}</span
                    >
                  </td>
                  <td class="text-right">
                    <button class="btn-table-action" matTooltip="View Details">
                      <i class="bi bi-eye"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
           <div class="pagination-row">
              <div class="showing-text">
                Showing
                 {{ showingFrom }} - {{ showingTo }} of {{ totalCandidates }}
              </div>
              <div class="pagination-controls">
                <button
                  class="pag-btn"
                  [disabled]="Page === 1"
                  (click)="prevPage()"
                >
                  <span class="material-icons"> chevron_left </span>
                </button>
                <span class="page-indicator">
                  Page {{ Page }} / {{ totalPages }}
                </span>
                <button
                  class="pag-btn"
                  [disabled]="Page === totalPages"
                  (click)="nextPage()"
                >
                  <span class="material-icons"> chevron_right </span>
                </button>
              </div>
            </div>
        </div>
      </div> not using this table for now , but later we can used this-->
    </ng-container>
    <ng-template #showMessage>
      <p class="text-center mt-5">No company details found</p>
    </ng-template>
  </ng-template>
</div>